import React from "react";

import GetIcon from "Components/Global/Icons";

import * as S from "./styles";

function IconSelect({ icons = [], selectedIcon, setSelectedIcon }) {
  return (
    <S.Wrapper>
      <label htmlFor="icon">Selecione um ícone</label>
      <S.IconWrapper>
        {icons.map((icon, index) => (
          <S.Icon
            key={index}
            selected={icon === selectedIcon}
            onClick={() => setSelectedIcon(selectedIcon === icon ? null : icon)}
          >
            <GetIcon name={icon} />
          </S.Icon>
        ))}
      </S.IconWrapper>
    </S.Wrapper>
  );
}

export default IconSelect;
